import * as t from 'io-ts';

import {makeApiType} from './apiTypes';
import {parseCardGroup, RCardGroup} from './cardGroupModel';

/*
 * Runtime type.
 */

const RSearchCardGroupsDirty = t.readonly(
  t.type({
    next: t.union([t.string, t.undefined]),
    cardGroups: t.readonlyArray(RCardGroup),
  }),
);

/*
 * Type.
 */

export interface SearchCardGroupsModel extends t.TypeOf<typeof RSearchCardGroupsDirty> {}
export const RSearchCardGroups = t.clean<SearchCardGroupsModel>(RSearchCardGroupsDirty as any);

/*
 * IO methods.
 */

function parseSearchCardGroups(src: any): SearchCardGroupsModel {
  return {
    next: src.next || undefined,
    cardGroups: src.results && src.results.map((cardGroup: any) => parseCardGroup(cardGroup)),
  };
}

/*
 * API type.
 */

export const ApiSearchCardGroups = makeApiType('searchCardGroups', RSearchCardGroups, parseSearchCardGroups);
